import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
@Component({
  selector: 'app-admincolaboradores',
  templateUrl: './admincolaboradores.component.html',
  styleUrls: ['./admincolaboradores.component.scss']
})

export class AdmincolaboradoresComponent implements OnInit{


  user;
  userId = '';
  ampa;

  // datos de la tabla
  displayedColumns = ['select','imagen', 'nombre',  'direccion', 'telefono',  'tipo', 'url', 'descripcion', 'acciones'];


  selection = new SelectionModel<ColaboradoresData>(true, []);
  dataSource: MatTableDataSource<ColaboradoresData>;
  colaboradores: ColaboradoresData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public map: any = { lat: 39.944204, lng: 0.091394 };

  constructor( private router: Router ) {
    console.log('constructor')
  }

   ngOnInit() {

     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.colaboradores);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerColaboradores();
       })
     }
  }

  // nos traemos los colaboradores del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerColaboradores(){
    console.log('obtenerColaboradores')
    firebase.firestore().collection('colaboradores')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: ColaboradoresData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.colaboradores = [...this.colaboradores, <ColaboradoresData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.colaboradores);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  // mostramos los datos del colaborador id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/colaboradores/ver/' + row.id]);
  }

  // eliminar colaboradores seleccionados
  eliminar(){
      this.selection.selected.forEach((colaborador) => {
        firebase.firestore().collection('colaboradores').doc(colaborador.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrado colaborador ' + colaborador.id)
        })
      });
      this.colaboradores = [];
      this.obtenerColaboradores();
  }

  // actualizamos los datos de algunos campos del colaborador id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/colaboradores/editar/' + row.id])
  }

  //exportamos a xlsx datos de colaboradores seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Colaboradores");
    XLSX.writeFile(wb, 'colaboradores.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

}

export interface ColaboradoresData {
  imagen: string;
  id: string;
  nombre: string;
  direccion: string;
  direccionform: string;
  telefono: string;
  lat: string;
  lng: string;
  url: string;
  tipo: string;
  descripcion: string;
  }



// WEBPACK FOOTER //
// ./src/app/admincolaboradores/admincolaboradores.component.ts